<template>
    <el-form ref="formRef" :model="formData" :rules="rules" label-width="120px">
         <el-form-item :label="dimension.display_name +'维度'" prop="dimension">
            <ESelect v-model="formData.dimension">
                <el-option 
                    v-for="item in dimensionList"
                    :key="item.name"
                    :label="item.display_name"
                    :value="item.name"
                />
            </ESelect>
        </el-form-item>
        <el-form-item label="排序条件" prop="order_by">
            <ESelect v-model="formData.order_by" clearable>
                <el-option 
                    v-for="item in optionFieldsList"
                    :key="item.name"
                    :label="item.display_name"
                    :value="item.name"
                />
            </ESelect>
        </el-form-item>
       <template v-if="!!formData.order_by">
            <el-form-item label="排序方式" prop="order_type" required>
                <el-radio-group v-model="formData.order_type">
                    <el-radio  label="desc">降序</el-radio>
                    <el-radio  label="asc">升序</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="展示数量" prop="show_type">
                <el-radio-group 
                    v-model="formData.show_type"
                    @change="()=>$refs['formRef'].clearValidate()"
                >
                    <el-radio 
                        v-for="item in numTypeList"
                        :key="item.value"
                        :label="item.value"
                    >
                        {{ item.label }}
                    </el-radio>
                </el-radio-group>
                <div class="mt10 ml80">
                    <el-input-number
                        v-if="isCustom"
                        v-model="formData.show_num" 
                        size="mini"
                        controls-position="right" 
                        :min="1" :step="1" 
                        placeholder="输入要展示的数量"
                    />
                </div>
            </el-form-item>
       </template>
        
    </el-form>
</template>

<script>
import { DIMENSION_TYPE_DATA_LIST, NUM_TYPE } from '../../constant'

export default {
    name: 'DateDimensionForm',
    props: [ 'defaultData', 'optionFieldsList', 'dimension' ],
    data() {

        const checkNumType = (rule, value, callback)=> {
            if ( value !== NUM_TYPE.CUSTOM) {
                callback()
            }else {
                const data = this.formData.show_num;
                if (!data) {
                     callback(new Error('请输入展示数量'))
                }else {
                    callback()
                }
            }
        }
        const { order_by, order_type, show_num, dimension } = this.defaultData || {};
        return {
            formData: {
                dimension,
                order_by: order_by || null,
                order_type: order_type || 'desc',
                show_num:  show_num || 1,
                show_type: show_num? NUM_TYPE.CUSTOM : NUM_TYPE.All
            },
            numTypeList: [
                { label:'全部', value: NUM_TYPE.All },
                { label:'自定义', value: NUM_TYPE.CUSTOM },
            ],
            rules: {
                show_type: [
                    { required: true, trigger: 'blur' },
                    { validator: checkNumType, trigger: 'blur' }
                ],
                dimension: [
                    { required: true, trigger: 'blur' ,  message: '请选择维度'},
                ],
            }
        }
    },
    computed: {
        isCustom() {
            return this.formData.show_type === NUM_TYPE.CUSTOM
        },
        dimensionList() {
            return DIMENSION_TYPE_DATA_LIST[this.dimension.name] || []
        }
    },
    methods: {
        async getFormData() {
            const valid = await this.$refs['formRef'].validate();
            if (valid) {
                const { order_by, order_type, show_num, show_type , dimension} = this.formData;
                
                const params = { dimension };
                if (order_by) {
                    params.order_type = order_type;
                    params.order_by = order_by
                    if (show_type === NUM_TYPE.CUSTOM ) {
                        params.show_num = show_num;
                    }else {
                        params.show_num = null;
                    };
                };
                return params;
            }
        }
    }
}
</script>

<style lang="scss" scoped>

</style>